"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
// TUNE-12025: the adswizz listener id and global function are
// set internally by the AdsWizz SDK scripts in Mint
var _default = exports["default"] = function _default() {
  return window.com_adswizz_synchro_getListenerId && window.com_adswizz_synchro_getListenerId();
};
//# sourceMappingURL=getAdswizzListenerId.js.map